import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Container, Group, Stack } from "@mantine/core";
import { TextInput } from "react-hook-form-mantine";
import { useForm } from "react-hook-form";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import { useCreateDocumentTemplate } from "../../api/user";
import resolver from "@congrs/resolver";
import { web_createDocumentTemplateSchema } from "@congrs/schemas";

function CreateTemplate() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);

  const { control, handleSubmit } = useForm({
    defaultValues: {
      eventId: currentWorkspace.eventId,
      name: "",
    },
    resolver: resolver(web_createDocumentTemplateSchema),
  });

  const { mutate: createTemplate, isPending } = useCreateDocumentTemplate();

  const onFormSubmit = (values) => {
    const defaultDocumentData = {
      documentSize: "210mm x 297mm",
      hasBackground: false,
      fields: [],
    };

    createTemplate(
      {
        eventId: currentWorkspace.eventId,
        name: values.name,
        documentData: defaultDocumentData,
      },
      {
        onSuccess: (data) => {
          // Immediately redirect to edit view to finish building
          if (data && data.id) {
            navigate(`/app/documents/document-templates/${data.id}`);
          } else {
            navigate("/app/documents?tab=templates");
          }
        },
      }
    );
  };

  return (
    <Container size="sm" p={0}>
      <Card shadow="sm" radius="md" p="xl" withBorder>
        <Stack>
          <form onSubmit={handleSubmit(onFormSubmit)}>
            <Stack>
              <TextInput
                label="Template Name"
                placeholder="Certificate of Attendance"
                name="name"
                control={control}
                withAsterisk
              />
              <Group justify="flex-end" mt="md">
                <Button
                  component={Link}
                  to="/app/documents?tab=templates"
                  variant="subtle"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  leftSection={<IconDeviceFloppy size={16} />}
                  loading={isPending}
                >
                  Create & Edit Layout
                </Button>
              </Group>
            </Stack>
          </form>
        </Stack>
      </Card>
    </Container>
  );
}

export default CreateTemplate;
